/**
 * Browser Media Query Helpers
 */

/**
 * Returns true if the user's browser has reduced motion turned on
 */
export function prefersReducedMotion(): boolean {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Returns true if the user's browser is small enough to be considered mobile resolution
 */
export function isMobile(breakpoint?:number): boolean {
    if (breakpoint){
        return window.innerWidth < breakpoint;
    }else{
        return window.innerWidth < 769; // Matches md screen breakpoint
    }
}
